module.exports = __webpack_public_path__ + "img/timeline-xl-fr.25038f2b.jpg";